export const normalizeCbu = (value) => String(value || '').replace(/\D/g, '');

const calculateCbuCheckDigit = (digits, weights) => {
  const total = digits
    .split('')
    .reduce((sum, digit, index) => sum + Number(digit) * weights[index], 0);

  return (10 - (total % 10)) % 10;
};

export const isValidCbu = (value) => {
  const cbu = normalizeCbu(value);
  if (!/^\d{22}$/.test(cbu)) return false;

  const firstBlock = cbu.slice(0, 8);
  const secondBlock = cbu.slice(8);

  const firstCheckDigit = calculateCbuCheckDigit(
    firstBlock.slice(0, 7),
    [7, 1, 3, 9, 7, 1, 3]
  );
  const secondCheckDigit = calculateCbuCheckDigit(
    secondBlock.slice(0, 13),
    [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3]
  );

  return firstCheckDigit === Number(firstBlock[7]) && secondCheckDigit === Number(secondBlock[13]);
};

export const getCbuValidationError = (value, { required = false } = {}) => {
  const cbu = normalizeCbu(value);
  if (!cbu) return required ? 'El CBU es obligatorio' : '';
  if (cbu.length < 22) return `CBU incompleto: ingresaste ${cbu.length} de 22 dígitos`;
  if (cbu.length > 22) return `CBU demasiado largo: ingresaste ${cbu.length} dígitos y deben ser 22`;
  if (!isValidCbu(cbu)) {
    return 'CBU inválido: los dígitos verificadores no coinciden. Revisá que esté copiado completo';
  }
  return '';
};

export const getCbuValidationMessage = (value, options = {}) => {
  const error = getCbuValidationError(value, options);
  return error || 'CBU válido';
};
